import type { NavigateFunction } from "react-router-dom";
import { fetchMetricSimplified } from "./bulkUpdateCamerasApi";
import {
  simplifiedMetricRowsMatchBulkFormExpectations,
  type ProductBulkFormRow,
  type ProductBulkFormState,
} from "../BulkUpdateWizardUtils";

export const DEFAULT_METRIC_SIMPLIFIED_POLL_MS = 60_000;
export const DEFAULT_METRIC_SIMPLIFIED_INTERVAL_MS = 2_000;

/**
 * Polls GET /metric/simplified/ until merged bulk form expectations match API rows or timeout.
 */
export const pollMetricSimplifiedUntilBulkExpectationsMet = async (
  navigate: NavigateFunction,
  customerId: number | string,
  selectedCameraIds: number[],
  formState: ProductBulkFormState,
  mergeSnapshot: { [cameraId: number]: { [productName: string]: boolean } | undefined },
  options?: {
    timeoutMs?: number;
    intervalMs?: number;
    productRows?: ProductBulkFormRow[];
  }
): Promise<boolean> => {
  const timeoutMs = options?.timeoutMs ?? DEFAULT_METRIC_SIMPLIFIED_POLL_MS;
  const intervalMs = options?.intervalMs ?? DEFAULT_METRIC_SIMPLIFIED_INTERVAL_MS;
  const deadline = Date.now() + timeoutMs;

  while (Date.now() < deadline) {
    const rows = await fetchMetricSimplified(navigate, customerId);
    if (
      simplifiedMetricRowsMatchBulkFormExpectations(
        rows,
        selectedCameraIds,
        formState,
        mergeSnapshot,
        options?.productRows
      )
    ) {
      return true;
    }
    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }
  return false;
};
